declare namespace FullCalendar {
    class Calendar {
        constructor(container: HTMLElement, options: any);
        render();
        setHeight(value: number);
        getEventSources(): any[];
        addEventSource(src: any);
    }
}

namespace Matrix.Scheduling {

    export interface CalendarViewOptions {
        calendarId: number;
    }

    export class CalendarView {

        private container: JQuery;
        private calendar: FullCalendar.Calendar;

        constructor(container: JQuery, opt: CalendarViewOptions) {

            this.container = container;

            this.calendar = new FullCalendar.Calendar(document.getElementById('FullCalendarDiv'), {
                initialView: 'dayGridMonth',
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,dayGridDay,listDay',
                },
                height: this.calcCalendarHeight()
            });
            this.calendar.render();

            var self = this;
            this.container.find('.calendar-checkbox').each((i, el) => {
                $(el).change(function () {
                    self.refresh();
                });
            });

            $(window).on('resize', () => {
                this.calendar.setHeight(this.calcCalendarHeight());
            });

            this.refresh();
        }

        private refresh() {

            var colors: string[] = [
                "#CD6155", "#9B59B6", "#2980B9", "#3498DB", "#16A085",
                "#E64D66", "#F1C40F", "#E67E22", "#34495E", "#5B2C6F"
            ];
            
            var colorIndex = 0;
            var colorByCalendarCode: Q.Dictionary<string> = {};
            this.container.find('.calendar-checkbox').each((i, el) => {
                $(el).next().css('color', colors[colorIndex]);
                $(el).css('background-color', colors[colorIndex]);
                var code = $(el).val();
                colorByCalendarCode[code] = colors[colorIndex];
                colorIndex++;
            });

            var calendarCodes = this.container.find('.calendar-checkbox:checked').toArray()
                .map(x => $(x).attr('value'));

            var sources = this.calendar.getEventSources();
            for (var i = 0; i < sources.length; i++) {
                var source = sources[i];
                source.remove();
            }
            if (calendarCodes.length) {
                Matrix.Scheduling.CalendarService.GetEntries({
                    CalendarCodes: calendarCodes
                },
                    (response) => {
                        this.calendar.addEventSource(response.Entities.map(function (x) {
                            var color = colorByCalendarCode[x.CalendarCode];
                            return {
                                title: x.Description,
                                start: Q.parseISODateTime(x.EntryDate),
                                allDay: true,
                                color: color
                            }
                        }));
                    }, { async: false });
            }
        }

        private calcCalendarHeight() {
            var availHeight = $(window).height() - 150;
            return Math.max(600, availHeight);
        }
    }
}